import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardBody, Container, Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { useFormik } from 'formik';
import TableContainer from 'components/Common/TableContainer';
import * as Yup from 'yup';
import Select from 'react-select';
import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { getCompletedWorkOrderListAPIURL, getFieldExecutiveListBySchedularAPIURL, getPaymentModeListAPIURL, getPendingWorkOrderListAPIURL, getSchedularUserListAPIURL, getWorkOrderListAPIURL, updateFieldExecutiveListAPIURL, updatePaymentModeAndReceivedAmtAPIURL, updateSchedularUserListAPIURL, updateWorkOrderListAPIURL } from 'BaseComponentAPI/WorkOrderListAPI';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTable, useSortBy, useGlobalFilter } from "react-table";


<style>
    {`
  .react-datepicker__triangle {
    left: 50%!important;
    transform: translateX(-50%);
  }
`}
</style>


const WorkOrderList = () => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";

    const navigate = useNavigate();

    const location = useLocation();

    const { fromDate, toDate, triggerFetch = false } = location.state || {};

    // console.log("Received From:", fromDate, "To:", toDate, "triggerFetch:", triggerFetch);

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const [pendingData, setPendingData] = useState([]);
    const [completedData, setCompletedData] = useState([]);

    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50]

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loaderOption, setLoaderOption] = useState(false);
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);

    const [schedulatData, setSchedularData] = useState([]);
    const schedularOptions = schedulatData.map(e => ({
        value: e.schedulerUUID,
        label: e.schedulerName
    }))
    const [fieldExecutiveData, setFieldExecutiveData] = useState([]);
    // console.log(fieldExecutiveData)

    const fieldExecutiveOptions = fieldExecutiveData.map(e => ({
        value: e.fieldExecutiveUUID,
        label: e.fieldExecutiveName
    }))
    const [WoStatusData, setWoStatusData] = useState([]);
    const WoStatusOptions = WoStatusData.map(e => ({
        value: e.woStatusUUID,
        label: e.woStatusText
    }))
    const [paymentModeData, setPaymentModeData] = useState([]);
    const paymentModeOptions = paymentModeData.map(e => ({
        value: e.paymentModeUUID,
        label: e.paymentMode
    }))

    useEffect(() => {
        if (triggerFetch) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);


    useEffect(() => {
        if (triggerFetch == true && fromDate && toDate) {
            formik.setFieldValue("startDate", moment(fromDate, "DD/MM/YYYY").toDate());
            formik.setFieldValue("endDate", moment(toDate, "DD/MM/YYYY").toDate());

            fetchWorkOrdersData(fromDate, toDate);
        }
    }, [triggerFetch]);


    // Handle date change (for both startDate and endDate)
    const handleDateChange = (date, field) => {
        setPendingData([]);
        setCompletedData([]);
        formik.setFieldValue(field, date);
    };

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const handlePageChange = async (newPageNo, newPageSize) => {
        // if (pendingData.length != 0) {
        //     if (authUser.headers && Object.keys(authUser.headers).length > 0) {
        //         // console.log(`API URL: ${getUserAudioRecordingsAPIURL}?employeeUUID=${values.employeeId}&journeyDate=${moment(values.date).format("DD/MM/YYYY")}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}}`);

        //         try {
        //             const response = await axios.get(
        //                 `${getUserAudioRecordingsAPIURL}?employeeUUID=${formik.values.employeeId}&startDate=${moment(formik.values.startDate).format("DD/MM/YYYY")}&endDate=${moment(formik.values.endDate).format("DD/MM/YYYY")}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
        //                 {
        //                     headers: { ...authUser.headers },
        //                     'Authorization': `Bearer ${authUser.headers.access_token}`
        //                 }
        //             );

        //             if (response.data.responseMsg == "Records not found") {
        //                 setLoaderOption(false);
        //                 setDisableSaveBtn(false);
        //                 openPopup('Records Not Found.', 'error')
        //             }
        //             else if (response.data.responseMsg == "Success") {
        //                 setPendingData(response.data.data.items);
        //                 setTotalPages(response.data.data.totalPages)
        //                 setTotalItems(response.data.data.totalItems);
        //                 setNextPage(response.data.data.nextPage);
        //                 setPreviousPage(response.data.data.previousPage);
        //                 setCurrentPage(response.data.data.currentPage);
        //                 setLoaderOption(false);
        //                 setDisableSaveBtn(false);
        //             }
        //             else {
        //                 console.error('API Response Error:', response.data.responseMsg);
        //                 setLoaderOption(false);
        //                 setDisableSaveBtn(false);
        //                 openPopup(response.data.responseMsg, 'error')
        //             }
        //         } catch (error) {
        //             console.error('Error fetching data:', error);
        //             setLoaderOption(false);
        //             setDisableSaveBtn(false);
        //             openPopup("Requested Data Not Found / 404", 'warn')
        //         }
        //         //  finally {
        //         //     setLoaderOption(false);
        //         // }
        //     }
        // }
    };

    // 🔹 Fetch Work Orders and auto-load Scheduler + Field Executive data
    const fetchWorkOrders = async (url, setter, { loadSupportLists = false } = {}) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    ...authUser.headers,
                    Authorization: `Bearer ${authUser.headers.access_token}`,
                },
            });

            const msg = response.data.responseMsg;

            if (msg == "Records not found") {
                setter([]);
                return { data: [], msg };  // ⭐ return msg also
            }

            if (msg == "Success") {
                const data = response.data.data || [];
                setter(data);

                if (loadSupportLists && data.length > 0) {
                    const woUUID = data[0].woUUID;
                    await Promise.all([
                        fetchSchedularList(woUUID),
                        fetchWorkOrderList(woUUID),
                        fetchPaymentModeList()
                    ]);
                }

                return { data, msg };  // ⭐ return msg
            }

            return { data: [], msg };

        } catch (error) {
            console.error("Error fetching data:", error);
            return { data: [], msg: "Requested Data Not Found / 404" };
        }
    };

    // ✅ Helper Functions (Schedular, WorkOrder, PaymentMode)
    // ✅ Helper Functions (Schedular, WorkOrder, PaymentMode)
    const fetchSchedularList = async (woUUID) => {
        try {
            const res = await axios.get(
                `${getSchedularUserListAPIURL}?userUUID=${authUser.headers.userUUID}&woUUID=${woUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                    },
                }
            );
            if (res.data.responseMsg == "Success") {
                setSchedularData(res.data.data.items || []);
            } else {
                console.error("Schedular API Response Error:", res.data.responseMsg);
            }
        } catch (err) {
            console.error("Error fetching schedular list:", err);
            openPopup("Requested Data Not Found / 404", "warn");
        }
    };

    const fetchWorkOrderList = async (woUUID) => {
        try {
            const res = await axios.get(
                `${getWorkOrderListAPIURL}?userUUID=${authUser.headers.userUUID}&woUUID=${woUUID}`,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                    },
                }
            );
            if (res.data.responseMsg == "Success") {
                setWoStatusData(res.data.data || []);
            } else {
                console.error("Work Order API Response Error:", res.data.responseMsg);
            }
        } catch (err) {
            console.error("Error fetching work order list:", err);
            openPopup("Requested Data Not Found / 404", "warn");
        }
    };

    const fetchPaymentModeList = async () => {
        try {
            const res = await axios.get(
                `${getPaymentModeListAPIURL}?userUUID=${authUser.headers.userUUID}`,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                    },
                }
            );
            if (res.data.responseMsg == "Success") {
                setPaymentModeData(res.data.data || []);
            } else {
                console.error("Payment Mode API Response Error:", res.data.responseMsg);
            }
        } catch (err) {
            console.error("Error fetching payment mode list:", err);
            openPopup("Requested Data Not Found / 404", "warn");
        }
    };

    let fePrefetchDone = false;
    // 🔹 Master function to fetch all Work Orders
    const fetchWorkOrdersData = async (startDate, endDate) => {
        setLoaderOption(true);
        const userUUID = authUser.headers.userUUID;

        // Reset FE prefetch flag
        fePrefetchDone = false;

        // 1️⃣ Fetch pending work orders AND supporting lists
        const pendingUrl =
            `${getPendingWorkOrderListAPIURL}?userUUID=${userUUID}&startDate=${startDate}&endDate=${endDate}`;

        const pendingResult = await fetchWorkOrders(pendingUrl, setPendingData, { loadSupportLists: true });

        if (pendingResult.data.length == 0) {
            openPopup(pendingResult.msg || "No pending work orders found", "warn");
        }

        // 2️⃣ Fetch completed work orders
        const completedUrl =
            `${getCompletedWorkOrderListAPIURL}?userUUID=${userUUID}&startDate=${startDate}&endDate=${endDate}`;

        const completedResult = await fetchWorkOrders(completedUrl, setCompletedData, { loadSupportLists: true });

        if (completedResult.data.length == 0) {
            openPopup(completedResult.msg || "No completed work orders found", "warn");
        }

        // 3️⃣ Prefetch Field Executives only ONCE
        if (!fePrefetchDone && Array.isArray(pendingResult.data)) {

            fePrefetchDone = true;  // ⭐ prevents second run

            const uniqueSchedulers = new Map();

            pendingResult.data.forEach(row => {
                if (row.schedulerUUID && row.woUUID) {
                    uniqueSchedulers.set(row.schedulerUUID, row.woUUID);
                }
            });

            for (let [schedulerUUID, woUUID] of uniqueSchedulers.entries()) {
                await getFieldExecutiveData(woUUID, schedulerUUID);
            }
        }

        setLoaderOption(false);
    };

    // ✅ Fetch Field Executive list based on Scheduler
    const getFieldExecutiveData = async (woUUID, schedulerUUID) => {
        if (!woUUID || !schedulerUUID) {
            setPendingData(prev =>
                prev.map(item =>
                    item.woUUID == woUUID
                        ? {
                            ...item,
                            fieldExecutiveOptions: [],
                            fieldExecutiveUUID: null,
                            fieldExecutiveName: null,
                        }
                        : item
                )
            );
            return;
        }

        try {
            const response = await axios.get(
                `${getFieldExecutiveListBySchedularAPIURL}?userUUID=${authUser.headers.userUUID}&woUUID=${woUUID}&woSchedulerUUID=${schedulerUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                    },
                }
            );

            if (response.data.responseMsg == "Success") {
                const fieldExecutiveList = response.data.data.items || [];

                const fieldExecutiveOptions = fieldExecutiveList.map(e => ({
                    value: e.fieldExecutiveUUID,
                    label: e.fieldExecutiveName,
                    schedulerUUID,
                }));

                // ✅ Assign fetched executives to all rows having same schedulerUUID
                setPendingData(prev =>
                    prev.map(item =>
                        item.schedulerUUID == schedulerUUID
                            ? {
                                ...item,
                                fieldExecutiveOptions,
                            }
                            : item
                    )
                );
            } else {
                console.error("API Response Error:", response.data.responseMsg);
                openPopup("Requested Data Not Found / 404", "warn");
            }
        } catch (error) {
            console.error("Error fetching field executives:", error);
            // Handle 404 / SSL / Timeout specific errors
            if (
                error.code == "ECONNABORTED" ||
                error.message?.includes("404") ||
                error.message?.includes("SSL")
            ) {
                openPopup("Requested Data Not Found / 404", "warn");
            } else {
                openPopup("Field Executive Data Not Found / 404", "warn");
            }
        }
    };

    const formik = useFormik({
        initialValues: {
            startDate: new Date(),
            endDate: new Date(),
        },
        validationSchema: Yup.object({
            startDate: Yup.date()
                .required('Start Date is required'),

            endDate: Yup.date()
                .required('End Date is required')
                .test(
                    "date-range",
                    "End Date should not be before Start Date and not more than 5 days later",
                    function (value) {
                        const { startDate } = this.parent;
                        if (startDate && value) {
                            const diff = moment(value).diff(moment(startDate), "days");

                            // ✅ allow same day (0) up to 5 days later
                            return diff >= 0 && diff < 4;
                        }
                        return true;
                    }
                ),
        }),

        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setPendingData([]);
            setCompletedData([]);

            if (!authUser.headers || Object.keys(authUser.headers).length == 0) return;

            const startDate = moment(values.startDate).format("DD/MM/YYYY");
            const endDate = moment(values.endDate).format("DD/MM/YYYY");

            // 🔹 Step 1: Fetch work orders first
            await fetchWorkOrdersData(startDate, endDate);

            // // 🔹 Step 2: Wait a bit for pendingData state update to complete
            // setTimeout(async () => {
            //     // Use the latest state (React batches state updates)
            //     setPendingData(prev => {
            //         const data = [...prev];

            //         // Collect all unique schedulerUUIDs from rows
            //         const uniqueSchedulers = new Map();
            //         data.forEach(row => {
            //             console.log(row.schedulerUUID + "----" + row.woUUID)
            //             if (row.schedulerUUID && row.woUUID) {
            //                 uniqueSchedulers.set(row.schedulerUUID, row.woUUID);
            //             }
            //         });

            //         // 🔹 Step 3: Call getFieldExecutiveData once per unique schedulerUUID
            //         uniqueSchedulers.forEach(async (woUUID, schedulerUUID) => {
            //             await getFieldExecutiveData(woUUID, schedulerUUID);
            //         });
            //         console.log(data);
            //         return data; // state unchanged
            //     });
            // }, 500);

            setDisableSaveBtn(false);
            setLoaderOption(false);
        }


    });

    const pendingColumns = useMemo(
        () => [
            {
                header: "Sr. No.",
                accessorKey: "woSeqNo",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Serial",
                accessorKey: "woSerialNo",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Type",
                accessorKey: "woType",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Execution Date",
                accessorKey: "woDate",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Execution Time",
                accessorKey: "woTime",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Amount ₹",
                accessorKey: "amount",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Product",
                accessorKey: "product",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Address - Area, Subarea",
                accessorKey: "woAreaSubArea",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Reserved",
                accessorKey: "reserved",
                enableColumnFilter: false,
                enableSorting: false,
            },

            {
                header: "Scheduler",
                accessorKey: "schedulerName",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Select
                        options={schedularOptions}
                        value={
                            schedularOptions.find(
                                opt => opt.value == row.original.schedulerUUID
                            ) || null
                        }
                        onChange={async (selected) => {
                            const updatedRow = {
                                ...row.original,
                                schedulerUUID: selected ? selected.value : null,
                                schedulerName: selected ? selected.label : null,

                                // Clear FE when scheduler changes
                                fieldExecutiveUUID: null,
                                fieldExecutiveName: null,
                                fieldExecutiveOptions: [],
                            };

                            setPendingData(prev =>
                                prev.map(item =>
                                    item.woUUID == row.original.woUUID ? updatedRow : item
                                )
                            );

                            if (selected) {
                                await getFieldExecutiveData(row.original.woUUID, selected.value);
                                await updateSchedularUser(row.original.woUUID, selected.value);
                            }
                        }}
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                width: 230,
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                backgroundColor: "#fff",   // ✅ force background
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", // ✅ hover + default
                                color: "#000",
                                cursor: "pointer",
                            }),
                            control: (provided, state) => ({
                                ...provided,
                                minHeight: "32px",
                                borderColor: state.isFocused ? "#2684FF" : "#ccc",
                                boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                                "&:hover": {
                                    borderColor: "#2569d0ff",
                                },
                            }),
                        }}
                    />
                ),
            },
            {
                header: "Field Executive",
                accessorKey: "fieldExecutiveName",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Select
                        options={row.original.fieldExecutiveOptions || []}
                        value={
                            row.original.fieldExecutiveUUID
                                ? {
                                    value: row.original.fieldExecutiveUUID,
                                    label: row.original.fieldExecutiveName,
                                }
                                : null
                        }
                        onChange={async (selected) => {
                            const updatedRow = {
                                ...row.original,
                                fieldExecutiveUUID: selected ? selected.value : null,
                                fieldExecutiveName: selected ? selected.label : null,
                            };

                            setPendingData(prev =>
                                prev.map(item =>
                                    item.woUUID == row.original.woUUID ? updatedRow : item
                                )
                            );

                            if (selected) {
                                await updateFieldExecutiveList(
                                    row.original.woUUID,
                                    row.original.schedulerUUID,
                                    selected.value
                                );
                            }
                        }}
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                width: 230,
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                backgroundColor: "#fff",   // ✅ force background
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", // ✅ hover + default
                                color: "#000",
                                cursor: "pointer",
                            }),
                            control: (provided, state) => ({
                                ...provided,
                                minHeight: "32px",
                                borderColor: state.isFocused ? "#2684FF" : "#ccc",
                                boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                                "&:hover": {
                                    borderColor: "#2569d0ff",
                                },
                            }),
                        }}
                    />
                ),
            },
            {
                header: "Payment Mode",
                accessorKey: "paymentMode",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Select
                        options={paymentModeOptions}
                        value={
                            paymentModeOptions.find(
                                opt => opt.value == row.original.paymentModeUUID
                            ) || null
                        }
                        onChange={async (selected) => {
                            const updatedRow = {
                                ...row.original,
                                paymentModeUUID: selected ? selected.value : null,
                                paymentMode: selected ? selected.label : null,

                                // Reset amount when payment mode changes
                                amountReceived: 0,
                            };

                            setPendingData(prev =>
                                prev.map(item =>
                                    item.woUUID == row.original.woUUID ? updatedRow : item
                                )
                            );

                            // ❌ Do NOT call API if null (fixes the popup!)
                            if (selected) {
                                await updatePaymentDetails(
                                    updatedRow.woUUID,
                                    updatedRow.paymentModeUUID,
                                    0
                                );
                            }
                        }}
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                width: 230,
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                backgroundColor: "#fff",   // ✅ force background
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", // ✅ hover + default
                                color: "#000",
                                cursor: "pointer",
                            }),
                            control: (provided, state) => ({
                                ...provided,
                                minHeight: "32px",
                                borderColor: state.isFocused ? "#2684FF" : "#ccc",
                                boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                                "&:hover": {
                                    borderColor: "#2569d0ff",
                                },
                            }),
                        }}
                    />
                ),
            },
            {
                header: "Received ₹",
                accessorKey: "amountReceived",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const [inputValue, setInputValue] = useState(row.original.amountReceived ?? 0);

                    const handleChange = (e) => {
                        setInputValue(e.target.value);
                    };

                    const handleBlur = async () => {
                        const numericValue = inputValue == "" ? 0 : Number(inputValue);

                        setPendingData(prev =>
                            prev.map((item) =>
                                item.woUUID == row.original.woUUID
                                    ? { ...item, amountReceived: numericValue }
                                    : item
                            )
                        );

                        const rowData = {
                            ...row.original,
                            amountReceived: numericValue,
                        };

                        // ❌ Prevent wrong API call (fix)
                        if (rowData.woUUID) {
                            await updatePaymentDetails(
                                rowData.woUUID,
                                rowData.paymentModeUUID,
                                numericValue
                            );
                        }
                    };

                    // Sync when payment mode changes
                    useEffect(() => {
                        setInputValue(row.original.amountReceived ?? 0);
                    }, [row.original.paymentModeUUID]);

                    return (
                        <Input
                            type="text"
                            value={inputValue}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            bsSize="md"
                            style={{ width: "100px" }}
                        />
                    );
                },
            },
            {
                header: "WO Status",
                accessorKey: "woStatus",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Select
                        options={WoStatusOptions}
                        value={
                            WoStatusOptions.find(opt => opt.value == row.original.woStatusUUID) || null
                        }
                        onChange={async (selected) => {

                            // 🚨 1️⃣ VALIDATION BEFORE API CALL
                            if (selected) {
                                if (!row.original.paymentModeUUID || !row.original.amountReceived) {
                                    openPopup("Payment Mode and Received Amount are required!", "warn");
                                    return; // ⛔ stop here
                                }
                            }

                            const updatedRow = {
                                ...row.original,
                                woStatusUUID: selected ? selected.value : null,
                                woStatusText: selected ? selected.label : null,
                            };

                            setPendingData(prev =>
                                prev.map(item =>
                                    item.woUUID == row.original.woUUID ? updatedRow : item
                                )
                            );

                            // 🚨 2️⃣ ONLY CALL API IF VALID
                            if (selected) {
                                await updateWorkOrderStatus(
                                    row.original.woUUID,
                                    selected.value
                                );
                            }
                        }}
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                width: 230,
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                backgroundColor: "#fff",   // ✅ force background
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", // ✅ hover + default
                                color: "#000",
                                cursor: "pointer",
                            }),
                            control: (provided, state) => ({
                                ...provided,
                                minHeight: "32px",
                                borderColor: state.isFocused ? "#2684FF" : "#ccc",
                                boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                                "&:hover": {
                                    borderColor: "#2569d0ff",
                                },
                            }),
                        }}
                    />
                ),
            }
            ,
            {
                header: "Balance ₹",
                accessorKey: "amountBalance",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Opened Date & Time",
                accessorKey: "woDetailsOpenedDateTime",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Action",
                accessorKey: "action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Button
                        color="success"
                        size="sm"
                        type='button'
                        onClick={() => {
                            const startDate = moment(formik.values.startDate).format("DD/MM/YYYY");
                            const endDate = moment(formik.values.endDate).format("DD/MM/YYYY");

                            navigate(`/workOrderDetails/${row.original.woUUID}/${row.original.woExeUUID}`, {
                                state: {
                                    fromDate: startDate,
                                    toDate: endDate
                                }
                            });
                        }}
                    >
                        WO Details
                    </Button>
                ),
            }
        ],
        [schedulatData, WoStatusData, paymentModeData, navigate] // ✅ Add navigate here
    );

    const completedColumns = useMemo(
        () => [
            {
                header: "Sr. No.",
                accessorKey: "woSeqNo",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Serial",
                accessorKey: "woSerialNo",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Type",
                accessorKey: "woType",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Execution Date",
                accessorKey: "woDate",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Execution Time",
                accessorKey: "woTime",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Amount ₹",
                accessorKey: "amount",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Product",
                accessorKey: "product",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Address - Area, Subarea",
                accessorKey: "woAreaSubArea",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Reserved",
                accessorKey: "reserved",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Scheduler",
                accessorKey: "schedulerName",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Field Executive",
                accessorKey: "fieldExecutiveName",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Status",
                accessorKey: "woStatus",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Payment Mode",
                accessorKey: "paymentMode",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Received ₹",
                accessorKey: "amountReceived",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Balance ₹",
                accessorKey: "amountBalance",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Opened Date & Time",
                accessorKey: "woDetailsOpenedDateTime",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Action",
                accessorKey: "action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Button
                        color="success"
                        size="sm"
                        type='button'
                        onClick={() => {
                            const startDate = moment(formik.values.startDate).format("DD/MM/YYYY");
                            const endDate = moment(formik.values.endDate).format("DD/MM/YYYY");

                            navigate(`/workOrderDetails/${row.original.woUUID}/${row.original.woExeUUID}`, {
                                state: {
                                    fromDate: startDate,
                                    toDate: endDate
                                }
                            });
                        }}
                    >
                        WO Details
                    </Button>
                ),
            }
        ],
        [schedulatData, WoStatusData, paymentModeData, navigate]
    );

    // useEffect(() => {
    //     pendingData.forEach(row => {
    //         if (row.schedulerUUID && (!row.fieldExecutiveOptions || row.fieldExecutiveOptions.length == 0)) {
    //             getFieldExecutiveData(row.woUUID, row.schedulerUUID);
    //         }
    //     });
    // }, [pendingData]);

    //update schedular user
    const updateSchedularUser = async (woUUID, schedulerUUID) => {
        if (!(authUser.headers && Object.keys(authUser.headers).length > 0)) return;

        try {
            const payload = {
                woUUID: woUUID,
                schedulerUUID: schedulerUUID,
                userUUID: authUser.headers.userUUID
            };

            // console.log("PATCH Payload:", payload);

            const response = await axios.patch(
                `${updateSchedularUserListAPIURL}`,
                payload,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            openPopup(response.data.responseMsg, "success");


        } catch (error) {
            console.error("Error updating scheduler user:", error.response?.data || error.message);
            openPopup(error.response?.data.responseMsg, "error");
        }
    };

    //update field executive list
    const updateFieldExecutiveList = async (woUUID, schedulerUUID, fieldExecutiveUUID) => {
        if (!(authUser.headers && Object.keys(authUser.headers).length > 0)) return;

        try {
            const payload = {
                woUUID: woUUID,
                schedulerUUID: schedulerUUID,
                userUUID: authUser.headers.userUUID,
                fieldExecutiveUUID: fieldExecutiveUUID
            };

            // console.log("PATCH Payload:", payload);

            const response = await axios.patch(
                `${updateFieldExecutiveListAPIURL}`,
                payload,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            openPopup(response.data.responseMsg, "success");


        } catch (error) {
            console.error("Error updating scheduler user:", error.response?.data || error.message);
            openPopup(error.response?.data.responseMsg, "error");
        }
    };

    //update payment and received
    const updatePaymentDetails = async (woUUID, paymentModeUUID, amountReceived) => {
        if (!(authUser.headers && Object.keys(authUser.headers).length > 0)) return;

        console.log(paymentModeUUID)
        // ⭐ Professional validation before calling API
        if (!paymentModeUUID) {
            openPopup("Please select a Payment Mode before updating payment details.", "warn");
            return;
        }

        try {
            const payload = {
                woUUID: woUUID,
                userUUID: authUser.headers.userUUID,
                paymentModeUUID: paymentModeUUID,
                receivedAmount: Number(amountReceived),
            };

            console.log(JSON.stringify(payload));

            const response = await axios.patch(
                `${updatePaymentModeAndReceivedAmtAPIURL}`,
                payload,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            openPopup(response.data.responseMsg, "success");

        } catch (error) {
            console.error("Error updating payment details:", error);
            openPopup(error.response?.data?.responseMsg || "API error", "error");
        }
    };

    const updateWorkOrderStatus = async (woUUID, WoStatusUUID) => {
        if (!(authUser.headers && Object.keys(authUser.headers).length > 0)) return;

        try {
            const payload = {
                woUUID,
                WoStatusUUID,
                userUUID: authUser.headers.userUUID,
            };
            // console.log(JSON.stringify(payload))

            const response = await axios.patch(
                `${updateWorkOrderListAPIURL}`,
                payload,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            openPopup(response.data.responseMsg, "success");

        } catch (error) {
            console.error("Error updating payment details:", error);
            openPopup(error.response.data.responseMsg || "API error", "error");
        }
    };


    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Work Order List" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Work Order List" />
                            <Card>
                                <CardBody className="border-bottom">
                                    <div style={{ padding: '20px' }}>

                                        <Form onSubmit={formik.handleSubmit}>

                                            <Row className='my-3'>
                                                {/* From Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="startDate">Start Date</Label>

                                                        <DatePicker
                                                            selected={formik.values.startDate}
                                                            onChange={(date) => {
                                                                handleDateChange(date, "startDate");
                                                                formik.setFieldValue("endDate", null);  // ⭐ MUST BE NULL
                                                            }}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select Start Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",

                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />


                                                        {formik.touched.startDate && formik.errors.startDate && (
                                                            <div style={{ color: "red", marginTop: "5px" }}>
                                                                {formik.errors.startDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>


                                                {/* To Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="endDate">End Date</Label>
                                                        <DatePicker
                                                            selected={formik.values.endDate}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select End Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",
                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />
                                                        {formik.touched.endDate && formik.errors.endDate && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.endDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                {/* Submit Button */}
                                                <Col md="12">
                                                    <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>

                                    {
                                        pendingData.length != 0
                                            ?
                                            <div className='mt-3'>
                                                {/* <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div> */}
                                                <h5 className="card-title mb-3" style={{ color: '#b72323' }}>
                                                    Pending Work Orders


                                                </h5>
                                                <TableContainer
                                                    columns={pendingColumns}
                                                    data={pendingData || []}
                                                    isGlobalFilter={true}
                                                    isPagination={false}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={false}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    }

                                    {
                                        completedData.length != 0
                                            ?
                                            <div className='mt-3'>
                                                {/* <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div> */}
                                                <h5 className="card-title mb-3" style={{ color: '#b72323' }}>
                                                    Completed Work Orders

                                                    
                                                </h5>
                                                <TableContainer
                                                    columns={completedColumns}
                                                    data={completedData || []}
                                                    isGlobalFilter={true}
                                                    isPagination={false}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={false}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    }
                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            );
        }
    }
}

WorkOrderList.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(WorkOrderList);